import { WeekProgress } from './types'

export const getReward = (week?: WeekProgress) => {
    if (!week) return 0
    const reward = week.rewardsThreshold.findLastIndex((threshold) => week.rewardsTotal >= threshold)
    return reward >= 0 ? reward + 1 : 0
}
